import React from 'react';
import { useTranslation } from '@/i18n';

interface FlagProps {
  width?: number;
  height?: number;
  className?: string;
}

export const QuebecFlag: React.FC<FlagProps> = ({ width = 24, height = 16, className = '' }) => {
  const { t } = useTranslation();
  const ariaLabelKey = 'common.flags.quebec';
  const ariaLabel = t(ariaLabelKey);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={ariaLabel === ariaLabelKey ? 'Quebec Flag' : ariaLabel}
    >
      {/* Blue background */}
      <rect width="24" height="16" fill="#003F8E" />
      
      {/* White cross */}
      <rect x="9.6" y="0" width="4.8" height="16" fill="white" />
      <rect x="0" y="5.6" width="24" height="4.8" fill="white" />
      
      {/* Fleur-de-lis symbols */}
      <g fill="white">
        {/* Top-left fleur-de-lis */}
        <path d="M4.8 2.8C4.8 2.8 4.5 2 3.8 2C3.1 2 2.8 2.8 2.8 2.8C2.8 2.8 2.3 2.5 2 3C1.7 3.5 2.2 4 2.2 4C2.2 4 1.8 4.5 2.3 4.8C2.8 5.1 3.3 4.6 3.3 4.6L3.8 5.5L4.3 4.6C4.3 4.6 4.8 5.1 5.3 4.8C5.8 4.5 5.4 4 5.4 4C5.4 4 5.9 3.5 5.6 3C5.3 2.5 4.8 2.8 4.8 2.8Z" />
        
        {/* Top-right fleur-de-lis */}
        <path d="M19.2 2.8C19.2 2.8 18.9 2 18.2 2C17.5 2 17.2 2.8 17.2 2.8C17.2 2.8 16.7 2.5 16.4 3C16.1 3.5 16.6 4 16.6 4C16.6 4 16.2 4.5 16.7 4.8C17.2 5.1 17.7 4.6 17.7 4.6L18.2 5.5L18.7 4.6C18.7 4.6 19.2 5.1 19.7 4.8C20.2 4.5 19.8 4 19.8 4C19.8 4 20.3 3.5 20 3C19.7 2.5 19.2 2.8 19.2 2.8Z" />
        
        {/* Bottom-left fleur-de-lis */}
        <path d="M4.8 11.2C4.8 11.2 4.5 10.4 3.8 10.4C3.1 10.4 2.8 11.2 2.8 11.2C2.8 11.2 2.3 10.9 2 11.4C1.7 11.9 2.2 12.4 2.2 12.4C2.2 12.4 1.8 12.9 2.3 13.2C2.8 13.5 3.3 13 3.3 13L3.8 13.9L4.3 13C4.3 13 4.8 13.5 5.3 13.2C5.8 12.9 5.4 12.4 5.4 12.4C5.4 12.4 5.9 11.9 5.6 11.4C5.3 10.9 4.8 11.2 4.8 11.2Z" />
        
        {/* Bottom-right fleur-de-lis */}
        <path d="M19.2 11.2C19.2 11.2 18.9 10.4 18.2 10.4C17.5 10.4 17.2 11.2 17.2 11.2C17.2 11.2 16.7 10.9 16.4 11.4C16.1 11.9 16.6 12.4 16.6 12.4C16.6 12.4 16.2 12.9 16.7 13.2C17.2 13.5 17.7 13 17.7 13L18.2 13.9L18.7 13C18.7 13 19.2 13.5 19.7 13.2C20.2 12.9 19.8 12.4 19.8 12.4C19.8 12.4 20.3 11.9 20 11.4C19.7 10.9 19.2 11.2 19.2 11.2Z" />
      </g>
    </svg>
  );
};

export default QuebecFlag;
